import { AxiosResponse } from 'axios';
import api from './axiosConfig';
import { invalidando } from './queryClient';
import {
  AnnouncementRequest,
  AnnouncementResponse,
  InboxDTO,
  NotificationPrefs,
} from '../types/dtos';
import { Page } from '../types';

export const CHAVES_NOTIFICACOES = {
  dominio: ['notificacoes'] as const,
  caixa: ['notificacoes', 'caixa'] as const,
  preferencias: ['notificacoes', 'preferencias'] as const,
  avisos: ['notificacoes', 'avisos'] as const,
};

const NotificationService = {
  // GET /api/v1/notifications — itens + total de não lidas numa resposta só.
  // `items` é uma Page aninhada, e o interceptor do axios só desembrulha a raiz.
  getInbox: (): Promise<AxiosResponse<InboxDTO>> =>
    api.get('/notifications').then((r) => ({ ...r, data: { ...r.data, items: r.data.items.content } })),

  // PUT /api/v1/notifications/{id}/read
  marcarComoLida: (id: string): Promise<AxiosResponse<void>> =>
    api.put(`/notifications/${id}/read`).then(invalidando(CHAVES_NOTIFICACOES.dominio)),

  // PUT /api/v1/notifications/read-all
  marcarTodasComoLidas: (): Promise<AxiosResponse<void>> =>
    api.put('/notifications/read-all').then(invalidando(CHAVES_NOTIFICACOES.dominio)),

  // GET /api/v1/notifications/preferences
  getPreferencias: (): Promise<AxiosResponse<NotificationPrefs>> =>
    api.get('/notifications/preferences'),

  // PUT /api/v1/notifications/preferences
  salvarPreferencias: (prefs: NotificationPrefs): Promise<AxiosResponse<NotificationPrefs>> =>
    api.put('/notifications/preferences', prefs),

  // GET /api/v1/notifications/push/key — vazia quando o push está desligado no servidor
  getChavePublica: (): Promise<AxiosResponse<{ publicKey: string }>> =>
    api.get('/notifications/push/key'),

  // POST /api/v1/notifications/push — idempotente pelo endpoint
  inscrever: (inscricao: {
    endpoint: string;
    p256dh: string;
    auth: string;
  }): Promise<AxiosResponse<void>> => api.post('/notifications/push', inscricao),

  // DELETE /api/v1/notifications/push?endpoint=...
  desinscrever: (endpoint: string): Promise<AxiosResponse<void>> =>
    api.delete('/notifications/push', { params: { endpoint } }),

  // ── Painel do DOMINUS ──────────────────────────────────────────────────────

  // GET /api/v1/admin/announcements?page= → Page<AnnouncementResponse>
  listarAvisos: (page: number): Promise<AxiosResponse<Page<AnnouncementResponse>>> =>
    api.get('/admin/announcements', { params: { page } }),

  // POST /api/v1/admin/announcements
  criarAviso: (aviso: AnnouncementRequest): Promise<AxiosResponse<AnnouncementResponse>> =>
    api.post('/admin/announcements', aviso).then(invalidando(CHAVES_NOTIFICACOES.avisos)),

  // PUT /api/v1/admin/announcements/{id}/active — pausa/retoma um recorrente
  alternarAviso: (id: string): Promise<AxiosResponse<AnnouncementResponse>> =>
    api.put(`/admin/announcements/${id}/active`).then(invalidando(CHAVES_NOTIFICACOES.avisos)),

  // DELETE /api/v1/admin/announcements/{id}
  apagarAviso: (id: string): Promise<AxiosResponse<void>> =>
    api.delete(`/admin/announcements/${id}`).then(invalidando(CHAVES_NOTIFICACOES.avisos)),

  // POST /api/v1/admin/announcements/dispatch — antecipa a varredura de 5 min
  dispararAgora: (): Promise<AxiosResponse<void>> =>
    api.post('/admin/announcements/dispatch').then(invalidando(CHAVES_NOTIFICACOES.avisos)),
};

export default NotificationService;
